// extracted by mini-css-extract-plugin
export default {"rincian-5":"infoCardStyle_rincian-5__Fw0H8","icon":"infoCardStyle_icon__Lei2W","iconPS":"infoCardStyle_iconPS__Su-NP","btn":"infoCardStyle_btn__dEwHW"};